var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcServer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 2.25C8.03 2.25 3.75 3.19 3.75 5.25V18.75C3.75 20.81 8.03 21.75 12 21.75C15.97 21.75 20.25 20.81 20.25 18.75V5.25C20.25 3.19 15.97 2.25 12 2.25ZM12 3.75C16.35 3.75 18.6 4.83 18.75 5.25C18.6 5.67 16.35 6.75 12 6.75C7.65 6.75 5.37 5.66 5.25 5.26C5.37 4.84 7.62 3.75 12 3.75ZM5.25 7.07C6.85 7.87 9.48 8.25 12 8.25C14.52 8.25 17.15 7.87 18.75 7.07V9.74C18.63 10.16 16.38 11.25 12 11.25C7.62 11.25 5.36 10.15 5.25 9.75V7.07ZM5.25 11.57C6.85 12.37 9.48 12.75 12 12.75C14.52 12.75 17.15 12.37 18.75 11.57V14.24C18.63 14.66 16.38 15.75 12 15.75C7.62 15.75 5.36 14.66 5.25 14.25V11.57ZM12 20.25C7.61 20.25 5.36 19.16 5.25 18.75V16.07C6.85 16.87 9.48 17.25 12 17.25C14.52 17.25 17.15 16.87 18.75 16.07V18.74C18.63 19.16 16.38 20.25 12 20.25Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcServer);
export default __webpack_public_path__ + "static/media/ic-server.e7ddc4719475c4ebddbf1b6e3b299ed4.svg";
export { ForwardRef as ReactComponent };